module.exports = __webpack_public_path__ + "assets/images/7gm.jpg";